import { render, staticRenderFns } from "./CancelDebtInstallments.vue?vue&type=template&id=c64c2370&"
import script from "./CancelDebtInstallments.vue?vue&type=script&lang=js&"
export * from "./CancelDebtInstallments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports